<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'

export default {

  name: 'MediaWidget',

  props: {
    content: [Object]
  },

  data () {
    return {
      tl: null
    }
  },

  methods: {
    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })
      const group = []

      if (this.$refs.title) group.push(this.$refs.title)
      if (this.$refs.content) group.push(this.$refs.content)

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: Power1.easeOut
      }, 0.1)

      tl.from(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        // onUpdate: () => {
        //   const y = this.$refs.media.style.opacity * 100

        //   Tween.set(this.$refs.media, {
        //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
        //   })
        // }
      }, 0.3)

      if (this.$refs.note) {
        tl.from(this.$refs.note, 1, {
          autoAlpha: 0,
          y: -20,
          ease: Power1.easeOut
        }, 1.2)
      }
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.widget
  .widget__content
    h2.widget__title(v-if="content.title" ref="title") {{ content.title }}
    .widget__description.markdown-container(v-if="content.description" v-md="content.description" ref="content")
    .widget__media(:class="['is-' + content.sizes]"): img(:src="content.media.url" alt="image" ref="media")
    .widget__note(v-if="content.note" ref="note") {{ content.note }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.widget
  padding-top 60px
  padding-bottom 60px
  display flex
  justify-content center

  +mobile()
    padding-top 35px
    padding-bottom 35px

  &__content
    max-width 1008px
    width 100%
    display flex
    flex-direction column
    align-items center

    +hd()
      max-width 1418px

    +mobile()
      padding 0 24px

  &__title
    width 554px
    max-width 46.5%
    min-width 455px
    font-weight 400
    font-size 56px
    line-height 57px
    color blue
    padding-bottom 35px

    +tablet()
      font-size 46px
      line-height 50px

    +mobile()
      min-width 0
      max-width 100%
      font-size 24px
      line-height 37px

    & + .widget__media
      padding-top 30px

  &__description
    width 554px
    max-width 46.5%
    min-width 455px
    font-size 17px
    line-height 25px
    padding-bottom 65px

    +mobile()
      min-width 0
      max-width 100%

  &__media
    position relative
    display flex
    align-items center
    justify-content center
    overflow hidden
    width 100%

    &.is-free img
      max-width 100%
      width 100%
      height auto

    &.is-1x1 img
    &.is-3x4 img
    &.is-16x9 img
      position absolute
      top 0
      left 0
      display block
      width 100%
      height 100%
      object-fit cover

    &.is-1x1
      width 668px
      height 668px

    &.is-3x4
      padding-top 75%

    &.is-16x9
      padding-top 56.25%

  &__note
    margin-top 36px
    width 554px
    max-width 46.5%
    min-width 455px
    font-size 12px
    line-height 20px
    color dark

    +mobile()
      margin-top 21px
      min-width 0
      max-width 100%
      font-size 11px
      line-height 17px
      font-weight 400

</style>



// WEBPACK FOOTER //
// media.vue?0327b5e6